import { loadSharedTemplates } from "../../../../packages/app-ui/js/templates.js";

const signedOutTemplate = `
  <div class="auth-shell">
    <div class="auth-card">
      <div class="auth-card__header">
        <div class="auth-logo">SiftText</div>
        <p class="auth-subtitle">fast, private transcripts for your audio</p>
      </div>
      <div id="app-sign-in" class="auth-signin-target"></div>
    </div>
  </div>
`;

function composeAppMarkup(partials) {
  const header = partials.header || "";
  const vending = partials.vending || "";
  const library = partials.library || "";
  const transcript = partials.transcript || "";
  return `${header}<main class=\"main-container\">${vending}${library}${transcript}</main>`;
}

export async function createAppShell(root, { templates } = {}) {
  if (!root) {
    throw new Error("app root element not found");
  }

  const sharedTemplates =
    templates ||
    (await loadSharedTemplates(["header", "vending", "library", "transcript"]));

  root.classList.add("app-root");
  root.setAttribute("data-template-root", "");

  function renderSignedOut() {
    document.body.classList.remove(
      "library-mode",
      "showing-transcript",
      "first-time-mode",
    );
    root.innerHTML = signedOutTemplate;
    const signInElement = root.querySelector("#app-sign-in");
    return { signInElement };
  }

  function renderAppLayout() {
    document.body.classList.remove(
      "library-mode",
      "first-time-mode",
      "showing-transcript",
    );
    root.innerHTML = composeAppMarkup(sharedTemplates);

    const headerActions = root.querySelector(".header-actions");
    let quotaBanner = null;
    let userButton = null;
    if (headerActions) {
      const appUtilities = document.createElement("div");
      appUtilities.className = "app-utilities";
      appUtilities.innerHTML = `
        <div id="app-quota-banner" class="quota-banner" aria-live="polite"></div>
        <div id="app-user-button" class="clerk-user-button">
          <div class="clerk-button-placeholder"></div>
        </div>
      `;
      headerActions.appendChild(appUtilities);
      quotaBanner = appUtilities.querySelector("#app-quota-banner");
      userButton = appUtilities.querySelector("#app-user-button");
    }

    // also mount user button in vending machine header
    const vmUserButton = root.querySelector("#vmUserButton");
    if (vmUserButton) {
      vmUserButton.innerHTML = `
        <div id="vm-user-button" class="clerk-user-button">
          <div class="clerk-button-placeholder"></div>
        </div>
      `;
    }

    const vendingMachineElement = root.querySelector("#vendingMachine");
    if (vendingMachineElement) {
      // hide vending by default; first-time users will see it once the app decides to show it
      vendingMachineElement.style.display = "none";
    }

    return {
      userButton,
      vmUserButton: vmUserButton
        ? vmUserButton.querySelector("#vm-user-button")
        : null,
      quotaBanner,
      fileInput: root.querySelector("#fileInput"),
      dropzone: root.querySelector(".dropzone"),
      libraryViewElement: root.querySelector("#libraryView"),
      transcriptViewElement: root.querySelector("#transcriptView"),
      vendingMachineElement,
    };
  }

  return {
    renderSignedOut,
    renderAppLayout,
  };
}
